/** @jsxImportSource react */
import ReadMoreContainer from '@react/profile/v2/components/ReadMoreContainer';
import { Link } from '@react/system';
import { formatMoney } from '@sly/core/helpers/numbers';
import { MoveIn } from '@sly/core/src/types';
import dayjs from 'dayjs';
import { useState } from 'react';

interface VerifiedMovesProps {
  moveIns: MoveIn[];
}

const VerifiedMoves = ({ moveIns }: VerifiedMovesProps) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <ul className='mt-l'>
        {moveIns?.slice(0, showMore ? 16 : 8)?.map((moveIn) => {
          return (
            <li
              className='border-b border-b-slate-lighter-90 py-3 px-l hover:bg-viridian-lighter-90'
              key={`${moveIn.name}${moveIn.date}${moveIn.fee}`}
            >
              <Link
                href={moveIn.path}
                target='_blank'
                rel='noopener noreferrer'
                eventProps={{
                  location: 'verified moves table search',
                  text: 'community opened',
                }}
              >
                <div className='flex flex-row justify-between gap-4 text-black'>
                  <p>{moveIn.name}</p>
                  <p>{formatMoney(moveIn.fee)}/mo</p>
                </div>
                <div className='flex flex-row justify-between gap-4 text-slate-lighter-40'>
                  <p>
                    {moveIn.care}, {moveIn.room}
                  </p>
                  <p className='whitespace-nowrap'>
                    {dayjs(moveIn.date).format('MMM, YYYY')}
                  </p>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
      {moveIns?.length > 8 && (
        <ReadMoreContainer
          className='ml-l no-underline'
          onClickHandler={() => {
            setShowMore(!showMore);
          }}
          eventProps={{
            location: 'verified moves table',
          }}
          readMoreText={showMore ? 'Show less' : 'Show more'}
          showArrow={false}
        />
      )}
    </>
  );
};

export default VerifiedMoves;
